import { render, staticRenderFns } from "./MessageEditorImagemap.vue?vue&type=template&id=39440f9f&scoped=true&"
import script from "./MessageEditorImagemap.vue?vue&type=script&lang=js&"
export * from "./MessageEditorImagemap.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorImagemap.vue?vue&type=style&index=0&id=39440f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39440f9f",
  null
  
)

export default component.exports